function o(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function n(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function r(t) {
  if (!n(t) && typeof t != "number")
    return !1;
  const e = o(t);
  return !isNaN(Number(e));
}
export {
  r as i,
  o as t
};
//# sourceMappingURL=isValid-DN-HkCoi.js.map
